"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategicOverviewVersionType = void 0;
var StrategicOverviewVersionType;
(function (StrategicOverviewVersionType) {
    StrategicOverviewVersionType["FORECAST_SYNC"] = "forecast_sync";
    StrategicOverviewVersionType["POTENTIAL_SYNC"] = "potential_sync";
    StrategicOverviewVersionType["MANUAL_SAVE"] = "manual_save";
    StrategicOverviewVersionType["MONTHLY_SNAPSHOT"] = "monthly_snapshot";
})(StrategicOverviewVersionType || (exports.StrategicOverviewVersionType = StrategicOverviewVersionType = {}));
